import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { EditorialHeading } from "./Reveal";

export const Testimonials = () => {
  const { t } = useLang();
  return (
    <section id="reviews" data-testid="testimonials-section" className="py-24 sm:py-32 bg-[#f4f1ec] border-y border-[#e8e5e0]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <EditorialHeading kicker={t.testimonials.kicker} lines={t.testimonials.lines} size="text-4xl sm:text-5xl lg:text-6xl" />

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {t.testimonials.items.map((r, i) => (
            <motion.blockquote
              key={i}
              data-testid={`testimonial-card-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className="relative rounded-xl border border-[#e8e5e0] bg-white p-7 flex flex-col shadow-sm hover:shadow-xl hover:shadow-neutral-200/70 hover:-translate-y-1 transition-[box-shadow,transform] duration-300"
            >
              <span className="font-display text-6xl leading-none text-[#dcd8d0] select-none">"</span>
              <div className="flex gap-1 mb-4 -mt-4">
                {Array.from({ length: 5 }).map((_, s) => (
                  <Star key={s} size={13} className="text-[#ff6b00] fill-[#ff6b00]" />
                ))}
              </div>
              <p className="text-sm text-neutral-600 leading-relaxed flex-1 font-display italic">"{r.text}"</p>
              <footer className="mt-6 pt-4 border-t border-[#eeebe5]">
                <p className="font-tech text-sm font-semibold text-neutral-900">{r.name}</p>
                <p className="font-tech text-[11px] tracking-widest uppercase text-neutral-400">{r.area}</p>
              </footer>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
};
